<template>
    <a class="flex items-center gap-2 group" href="tel:+441224611707">
        
        <!-- Icon -->
        <svg class="w-6 h-6 transition text-neutral-400 group-hover:text-neutral-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path fill-rule="evenodd" d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z" clip-rule="evenodd" />
        </svg>

        <!-- Text -->
        <p class="transition text-neutral-600 body-md group-hover:text-neutral-800 group-active:text-neutral-400">01224 611 707</p>

    </a>
</template>

<script>
    export default {
        
        name: 'Cta-Phone',
        
    };
</script>